module.exports = __webpack_public_path__ + "static/media/lot-8arDWebKne1BeJFpJDTAyuDgodD3kJ.df8fe38c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lot-8arDWebKne1BeJFpJDTAyuDgodD3kJ.webp
// module id = 639
// module chunks = 0